import React, { useState, useEffect } from "react";

const PdfThumbnail = ({ pdfUrl }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generateThumbnail = async () => {
      if (!window.pdfjsLib) {
        console.error("pdf.js library is not loaded.");
        setError("PDF library failed to load.");
        setIsLoading(false);
        return;
      }

      try {
        const loadingTask = window.pdfjsLib.getDocument(pdfUrl);
        const pdf = await loadingTask.promise;
        const page = await pdf.getPage(1);

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const viewport = page.getViewport({ scale: 1 });
        const scale = 300 / viewport.width;
        const scaledViewport = page.getViewport({ scale });

        canvas.height = scaledViewport.height;
        canvas.width = scaledViewport.width;

        await page.render({ canvasContext: context, viewport: scaledViewport })
          .promise;
        setThumbnailUrl(canvas.toDataURL("image/jpeg"));
      } catch (err) {
        console.error(
          "Failed to render PDF thumbnail for URL:",
          pdfUrl,
          "Error:",
          err
        );
        setError(
          "Could not load preview. This might be a CORS issue or an invalid PDF."
        );
        setThumbnailUrl(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (pdfUrl) {
      generateThumbnail();
    } else {
      setIsLoading(false);
    }
  }, [pdfUrl]);

  if (isLoading) {
    return (
      <div className="w-full h-80 bg-gray-200 flex items-center justify-center">
        Loading Preview...
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-80 bg-red-100 flex flex-col items-center justify-center text-center p-4">
        <p className="font-semibold text-red-700">Preview Failed</p>
        <p className="text-xs text-red-600 mt-1">{error}</p>
      </div>
    );
  }

  if (!thumbnailUrl) {
    return (
      <div className="w-full h-80 bg-gray-300 flex items-center justify-center text-gray-500">
        Preview Not Available
      </div>
    );
  }

  return (
    <img
      src={thumbnailUrl}
      alt="E-Paper Thumbnail"
      className="w-full h-80 object-cover object-top"
    />
  );
};

export default PdfThumbnail;
